import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";

const searchTypeMapper = {
    city: ['subcounty', 'county'],
    state: ['state'],
    location: ['site'],
    album: ['album'],
    user: ['user'],
};
const searchTypes = Object.keys(searchTypeMapper);

const SearchTypeMenuBar = (props) => {
    const {
        onSearchTypesChange,
    } = props;

    const [selectedType, setSelectedType] = useState(searchTypes[0]);

    useEffect(() => {
        onSearchTypesChange(searchTypeMapper[selectedType]);
    }, [selectedType]);

    return searchTypes.map((searchType, index) => (
        <button
            id={`search-${searchType}-btn`}
            key={searchType}
            className={classnames(
                "btn btn-sm rounded-pill me-2 mb-2 text-capitalize",
                (selectedType === searchType) ? "btn-secondary" : "btn-outline-secondary",
            )}
            onClick={() => setSelectedType(searchType)}
        >
            {searchType}
        </button>
    ));
};

SearchTypeMenuBar.propTypes = {
    onSearchTypesChange: PropTypes.func.isRequired,
};

export default SearchTypeMenuBar;
